(() => {
  const STORAGE_KEY = 'verymill_free_shipping_countdown_end';
  const DURATION_MS = 10 * 60 * 1000;

  const safeGet = () => {
    try { return Number(sessionStorage.getItem(STORAGE_KEY)); } catch (e) { return 0; }
  };
  const safeSet = (value) => {
    try { sessionStorage.setItem(STORAGE_KEY, String(value)); } catch (e) {}
  };
  const safeRemove = () => {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  };

  const format = (remainingMs) => {
    const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
  };

  const getGoals = () => Array.from(document.querySelectorAll('[data-vm-free-shipping-goal]'));

  const getPrimaryGoal = (goals) => {
    const activeDrawer = document.querySelector('.m-cart-drawer.m-cart-drawer--active, .m-cart-drawer--active');
    if (activeDrawer) {
      const activeGoal = activeDrawer.querySelector('[data-vm-free-shipping-goal]');
      if (activeGoal) return activeGoal;
    }
    const drawerGoal = document.querySelector('#MinimogCartDrawer [data-vm-free-shipping-goal]');
    if (drawerGoal) return drawerGoal;
    return goals[goals.length - 1] || null;
  };

  const tick = () => {
    const goals = getGoals();
    if (!goals.length) return;

    const unlockedGoals = goals.filter((goal) => goal.classList.contains('is-unlocked') || goal.querySelector('[data-vm-free-shipping-countdown]'));
    if (!unlockedGoals.length) {
      safeRemove();
      return;
    }

    let end = safeGet();
    if (!end || Number.isNaN(end)) {
      end = Date.now() + DURATION_MS;
      safeSet(end);
    }

    const remaining = Math.max(0, end - Date.now());
    const text = remaining <= 0 ? '0m 00s' : format(remaining);

    // Update every unlocked instance because Shopify can temporarily keep
    // more than one cart section in the DOM during section re-rendering.
    unlockedGoals.forEach((goal) => {
      const countdown = goal.querySelector('[data-vm-free-shipping-countdown]');
      if (countdown) countdown.textContent = text;
    });

    // Ensure the visible/active cart drawer is painted immediately.
    const primary = getPrimaryGoal(goals);
    if (primary && (primary.classList.contains('is-unlocked') || primary.querySelector('[data-vm-free-shipping-countdown]'))) {
      const countdown = primary.querySelector('[data-vm-free-shipping-countdown]');
      if (countdown) countdown.textContent = text;
    }
  };

  const kick = () => {
    tick();
    window.setTimeout(tick, 80);
    window.setTimeout(tick, 250);
  };

  // One stable clock. It survives Shopify section replacement because it
  // queries the live DOM on every tick instead of holding stale elements.
  kick();
  document.addEventListener('DOMContentLoaded', kick, { once: true });
  window.setInterval(tick, 1000);

  // Common cart/drawer events used by Minimog/FoxKit/Shopify themes.
  [
    'cart:updated', 'cart:refresh', 'cart-drawer:open', 'cart:change',
    'cart:build', 'cart-drawer:updated', 'product:added', 'ajaxProduct:added'
  ].forEach((eventName) => document.addEventListener(eventName, kick));
  document.addEventListener('cozecats:cart-goal-updated', kick);

  // Detect async cart drawer section replacement without reacting to the
  // countdown text itself: only kick when nodes containing a shipping goal
  // are inserted into the document.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('[data-vm-free-shipping-goal], #MinimogCartDrawer, .m-cart-drawer') ||
          node.querySelector?.('[data-vm-free-shipping-goal]')
        ) {
          kick();
          return;
        }
      }
    }
  });
  const observe = () => {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe, { once: true });
})();
